import React from 'react'

import Link from '@mui/material/Link'
import Typography from '@mui/material/Typography'

// Same URL the site-wide Footer links to (components/footer/Footer.js) —
// keep them in sync rather than letting each usage drift (issue #685).
export const TCAIREM_LINKEDIN_URL = 'https://www.linkedin.com/company/tcairem'

// Shared post-submission thank-you copy for the glossary term request modal
// (TerminologyForm) and the suggest-changes/revision modal
// (TerminologyRevisionModal), so both carry the same text and a working,
// new-tab LinkedIn link (issue #685).
const TerminologySubmissionThanks = () => (
    <Typography>
        Thank you for taking the time to contribute to our Living Glossary. The International AI Working Group has received your submission and appreciates your contributions. If there are any questions or concerns, a member of the group will reach out to you. We hope you’ll stay in touch with T-CAIREM by following us on <Link href={TCAIREM_LINKEDIN_URL} target="_blank" rel="noopener noreferrer">LinkedIn</Link>
    </Typography>
)

export default TerminologySubmissionThanks
